// import { createHashHistory } from 'history';
import { createBrowserHistory} from 'history';

export const history = createBrowserHistory();
